export default "<div style=\"position: relative;\" ng-style=\"{width: $ctrl.width, height: $ctrl.height}\">\n    <canvas></canvas>\n</div>\n"